const {
    cdn: { url: cdnUrl },
} = config;

export const getAsset = (staticName: string): string => `${cdnUrl}/apps/ebay-checkout/statics/${staticName}`;

export const getCarrierLogo = (logoId: string | undefined): string => `${cdnUrl}/apps/carrier-logos/${logoId}.svg`;
